<template>
  <ul class="nav nav-mobile-menu">
    <drop-down tag="li">
          <template slot="title">
            <i class="nc-icon nc-support-17"></i>
            <b class="caret"></b>
            <span class="notification">5</span> Bildirim
          </template>
          <a class="dropdown-item" href="#">Notification 1</a>
          <a class="dropdown-item" href="#">Notification 2</a>
          <a class="dropdown-item" href="#">Notification 3</a>
          <a class="dropdown-item" href="#">Notification 4</a>
          <a class="dropdown-item" href="#">Another notification</a>
        </drop-down>
        <drop-down tag="li">
          <template slot="title">
            <i class="nc-icon nc-circle-09"></i> Hesabim
            <b class="caret"></b>
          </template>
          <a class="dropdown-item" href="#">Profilim</a>
          <a class="dropdown-item" href="#">Ayarlarım</a>
        </drop-down>

    <li class="nav-item">
      <a class="nav-link" href="#pablo">
        <span class="nc-button-power">Çıkış</span>
      </a>
    </li>
  </ul>
</template>
<script>
  import DropDown from 'src/components/UIComponents/Dropdown.vue'

  export default {
    components: {
      DropDown
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Layout/MobileMenu.vue